module.exports = __webpack_public_path__ + "img/secai19.a33fff45.png";